import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SourceAuthService } from './source-auth.service';

export const sourceAuthGuard: CanActivateFn = () => {
  const auth = inject(SourceAuthService);
  const router = inject(Router);
  return auth.complete() ? true : router.createUrlTree(['/login']);
};

export const redirectIfSignedIn: CanActivateFn = () => {
  const auth = inject(SourceAuthService);
  const router = inject(Router);
  return auth.complete() ? router.createUrlTree(['/compare']) : true;
};
